import { ArrowBack } from '@mui/icons-material'
import { AppBar, Container, IconButton, Toolbar, Typography } from '@mui/material'
import { Link, useLocation } from 'react-router-dom'

type Props = {
  children?: React.ReactNode
}
const Header: React.FC<Props> = ({children}) => {
  const location = useLocation()
  const isArrowBack = ['/setting', '/admin'].includes(location.pathname)
  return <Container
    maxWidth='md' //disableGutters
    sx={{pt: 1}}
  >
    <AppBar
      position='static'
      sx={{
        bgcolor: 'white', color: 'black',
        borderRadius: 8
      }}
      elevation={1}
    >
      <Toolbar>
        {isArrowBack && <IconButton
          component={Link} to='/'
          sx={{textDecoration: 'none', color: 'inherit'}}
        >
          <ArrowBack/>
        </IconButton>}
        <Typography variant='h1' fontSize={28} fontWeight='bold'>
          Cheer
        </Typography>
        <div style={{flexGrow: 1}}/>
        {children}
      </Toolbar>
    </AppBar>
  </Container>
}

export default Header